import { type FC, type JSX } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { TENANT } from '../../../../tenant'

import {
  ProductPriceExplainerContentAt,
  ProductPriceExplainerContentBe,
  ProductPriceExplainerContentCh,
  ProductPriceExplainerContentCom,
  ProductPriceExplainerContentFr,
  ProductPriceExplainerContentIt,
} from './ProductPriceExplainerContent'

type ProductPriceExplainerProps = { onClose: () => void }

const getDialogContent = (tenant: TENANT): JSX.Element => {
  switch (tenant) {
    case TENANT.AT: {
      return <ProductPriceExplainerContentAt />
    }
    case TENANT.BE: {
      return <ProductPriceExplainerContentBe />
    }
    case TENANT.CH: {
      return <ProductPriceExplainerContentCh />
    }
    case TENANT.COM: {
      return <ProductPriceExplainerContentCom />
    }
    case TENANT.FR: {
      return <ProductPriceExplainerContentFr />
    }
    case TENANT.IT: {
      return <ProductPriceExplainerContentIt />
    }
    default: {
      return <ProductPriceExplainerContentCom />
    }
  }
}

export const ProductPriceExplainerDialog: FC<ProductPriceExplainerProps> = ({
  onClose,
}) => {
  const { tenant } = useGlobalConfigContext()

  return (
    <Dialog data-qa-id="product-price-explainer" onClose={onClose} open>
      <DialogTitle onClose={onClose}>
        <FormattedMessage id="product.legalPriceInformation.heading" />
      </DialogTitle>
      <DialogContent>{getDialogContent(tenant)}</DialogContent>
    </Dialog>
  )
}
